export const findLocationBreadcrumbs = (path, lastItem) => {
  let result: any = [];
  const splitted = path.split('/').splice(1);

  splitted.forEach((item, ind) => {
    const joinedSlug = '/' + splitted.slice(0, ind + 1).join('/');

    result.push({
      name: item,
      slug: joinedSlug,
    });
  });

  return result;
};
